// Libarary
import { Injectable } from '@angular/core';

// Service
import { ConfigService } from './../../infrastructure/config.service';
import { NetworkService } from './../../infrastructure/network.service';

@Injectable()
export class TotalOrderSummaryService {
  constructor(public configService: ConfigService,
    private networkService: NetworkService) {
  }

  // Get Total Order Summary
  public getTotalOrderSummaryData(tosLevel, filter) {
    return this.networkService.postRequest(this.configService.getTotalOrderSummaryDataUrl() + '?tosLevel=' + tosLevel, filter);
  }
}
